export const ROUTES = {
  LOGIN: "/",
  MAINTENANCE: "/maintenance",
  REGISTER: "/register",
  TERMS: "/terms",
  BUY_EQUITY: "/auth/buyequity",
  EMAIL_VERIFICATION: "/email-verification",
  SET_NEW_PASSWORD: "/new-password",
  RESET_PASSWORD: "/reset-password",
  FORGOT_EMAIL_VERIFICATION: "/forgot-password",
  SECURITY_VERIFICATION: "/security-verification",
  UNSUBSCRIBE: "/unsubscribe",
  AUTH: "/auth",
  DASHBOARD: "/auth/dashboard",
  INVESTMENTS: "/auth/investments",
  MARKETPLACE: "/auth/marketplace",
  TRANSACTIONS: "/auth/transactions",
  ORDERS: "/auth/orders",
  SETTINGS: "/auth/settings",
  HELP: "/auth/help",
  BUY: "/auth/dashboard/p2ptab/buy",
  SELL: "/auth/dashboard/p2ptab/sell",
  P2P: "/auth/dashboard/p2ptab",
  REDEEM: "/auth/dashboard/redeem",
  CONVERT: "/auth/dashboard/convert",
  TRANSACTIONS_OPENED: "/auth/transactions/opened",
  TRANSACTIONS_COMPLETED: "/auth/transactions/completed",
  ORDERS_OPENED: "/auth/orders/opened",
  ORDERS_COMPLETED: "/auth/orders/completed",
  HELP_FEATURE_1: "/auth/help/feature-1",
  HELP_FEATURE_2: "/auth/help/feature-2",
  HELP_FEATURE_3: "/auth/help/feature-3",
  HELP_FEATURE_4: "/auth/help/feature-4",
  MY_PROFILE: "/auth/settings/my-profile",
  FEES: "/auth/settings/fees",
  TERMS_CONDITIONS: "/auth/settings/terms-conditions",
  PRIVACY_POLICY: "/auth/settings/privacy-policy",
  P2P_ORDERS: "/auth/p2p-orders",
  P2P_ORDERS_LIST: "/auth/p2p-orders/list",
  MY_ORDERS: "/auth/p2p-orders/my-orders",
  PAYMENT_STATUS: "/auth/payment-status",
  WALLETPORTFOLIO: "/auth/wallet-portfolio",
  CRYPTOWALLET: "/auth/crypto-wallet",
  REPORT: "/auth/report",
  REPORTDETAILS: "/auth/report-detail",
  DESPOSIT_TRANSACTIONS: "/auth/desposit-transaction",
  ALL_COINS: "/auth/desposit-transaction/all",
  DESPOSIT: "/auth/desposit-transaction/deposit",
  WIDTHROW: "/auth/desposit-transaction/widthrow",
  VERIFY_KYC: "/auth/verify-kyc",
  APPLY_CARD: "/auth/apply-card",
  APPLY_CARD_FORM: "/auth/apply-card/card-form",
  STBL_MONEY: "/auth/stbl-money",
  CARD_SETTINGS: "/auth/stbl-money/card-settings",
  FREEZE_CARD: "/auth/stbl-money/freeze-card",
  CARD_STATEMENT: "/auth/stbl-money/card-statement",
  MANAGE_CARD: "/auth/stbl-money/manage-card",
  AMOUNT_DETAILS: "/auth/stbl-money/amount-details",
  VIEW_CARD_PIN: "/auth/stbl-money/view-card-pin",
  SET_UPDATE_CARD_PIN: "/auth/stbl-money/set-update-card-pin",
  REPORT_ISSUES: "/auth/stbl-money/report-issues",
  RECENT_TRANSACTIONS: "/auth/stbl-money/recent-transactions",
  VIEW_STATEMENT: "/auth/stbl-money/view-statement",
  PRIVACY_NOTICE: "/auth/card/privacy",
  ISSUER_PRIVACY_POLICY_INTERNATIONAL: "/auth/card/issuer-privacy-policy",
  ESIGN_CONSENT: "/auth/card/e-sign-consent",
  THIRD_PARTY_ESIGN_CONSENT:
    "https://legal.raincards.xyz/legal/electronic-communications-notice",
  THIRD_PARTY_ACCOUNT_OPENING_PRIVACY_NOTICE:
    "https://legal.raincards.xyz/legal/account-opening-privacy-notice-third-national",
  CARD_TERMS_US: "/legal/card-terms-us",
  CARD_TERMS_INTERNATIONAL: "/auth/card/terms-international",
  PROHIBITIONS: "/auth/card/prohibited",
  CARD_TERMS: "/auth/card/terms",
  CARD_DISCLOSURES_AGREEMENT: "/auth/card/disclosures-agreement",
  ACCOUNT_OPENING_PRIVACY_NOTICE: "/auth/card/account-opening-privacy-notice",
};
